import React from "react";
import { PlansDisplayHeader } from "components/views/plansDisplay/PlansDisplayHeader";
import { PlansDisplayTable } from "components/views/plansDisplay/PlansDisplayTable";
import { FullscreenView } from "components/utils/FullscreenView";
import { edstFontDim } from "@poscon/shared-frontend";

export const PlansDisplay = () => (
  <FullscreenView view="PLANS_DISPLAY" HeaderComponent={PlansDisplayHeader} BodyComponent={PlansDisplayTable} minWidth={edstFontDim.width * 70} />
);
